<template>
  <accordion-panel
    :id="id"
    :collapsed.sync="collapsed"
  >
    <template slot="title">
      <slot name="title"/>
    </template>
    <template slot="controls">
      <slot name="controls"/>
    </template>
    <template>
      <slot/>
    </template>
  </accordion-panel>
</template>

<script>
import AccordionPanel from './AccordionPanel';

export default {
  components: {
    AccordionPanel,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    collapsed: true,
  }),
  methods: {
    onChangeCollapsed(value) {
      this.collapsed = value;
    },
  },
};
</script>
